module.exports = {
  SET_SNACKBAR: 'SET_SNACKBAR',
  RECEIVED_HOSTED_LINKS: 'RECEIVED_HOSTED_LINKS',
  SET_LOCAL_IPADDRESS: 'SET_LOCAL_IPADDRESS',
  PLANS: {
    os: 'Mender Starter',
    professional: 'Mender Professional',
    enterprise: 'Mender Enterprise'
  }
};
